import { AttributesMixin, define, Model, type } from "@type-r/models";
import { RemittanceAdvicePayeesLookup, RemittanceAdvicePayorsLookup } from "../../api/lookups";
import { RemittanceAdviceFilter } from "./remittance-advice-fillter";

export interface RemittanceAdviceStore extends AttributesMixin<typeof RemittanceAdviceStore> { }
@define
export class RemittanceAdviceStore extends Model {
  static attributes = {
    filter: type(RemittanceAdviceFilter),
    payors: RemittanceAdvicePayorsLookup,
    payees: RemittanceAdvicePayeesLookup
  }

  initialize() {
    this.filter.payors.set({
      selected: [],
      placeholder: 'Payor Name',
      options: Array.from(new Set(this.payors.items.map(x => x.name)))        
  })
  this.filter.payees.set({
      selected: [],
      placeholder: 'Payee Name',
      options: Array.from(new Set(this.payees.items.map(x => x.name)))        
  })
  }
}